<template>
  <SoPageWithHeader title="Draws">
    <OpsDrawListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import OpsDrawListTable from "@/views/operations/loyalty/components/OpsDrawListTable.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      OpsDrawListTable,
    },
  })
</script>
